import LoginTwoFa from './LoginTwoFa'

export default LoginTwoFa
